/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FreeDayCreate } from '../models/FreeDayCreate';
import type { FreeDayCreatedListe } from '../models/FreeDayCreatedListe';
import type { FreeDayListe } from '../models/FreeDayListe';
import type { Mandant } from '../models/Mandant';
import type { MandantDaten } from '../models/MandantDaten';
import type { MandantenListe } from '../models/MandantenListe';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MandantenService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Eine Liste aller Mandanten
   * Gibt eine Liste aller Mandanten zurück
   * @returns MandantenListe Liste der gesuchten Mandanten
   * @throws ApiError
   */
  public searchMandanten({
    search,
    filtered,
    page,
    limit,
    sort,
  }: {
    /**
     * Suchstring für Mandanten
     */
    search?: string,
    /**
     * Filterstring für Mandanten Seite
     */
    filtered?: string,
    /**
     * Seitenzahl der Mandanten Seite
     */
    page?: number,
    /**
     * Limit der Liste von Mandanten Einträgen
     */
    limit?: number,
    /**
     * Sortierung der Mandanten Seite
     */
    sort?: string,
  }): CancelablePromise<MandantenListe> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/mandanten',
      query: {
        'search': search,
        'filtered': filtered,
        'page': page,
        'limit': limit,
        'sort': sort,
      },
      errors: {
        400: `Bad Request for this request (searchMandanten)`,
        401: `Unauthorized for this request (searchMandanten)`,
        403: `Forbidden for this request (searchMandanten)`,
        404: `Not Found for this request (searchMandanten)`,
      },
    });
  }

  /**
   * Einen Mandanten erstellen
   * Erstellt einen Mandanten
   * @returns Mandant Der erstellte Mandant
   * @throws ApiError
   */
  public createMandant({
    requestBody,
  }: {
    /**
     * Daten, mit welchen der Mandant erstellt werden soll
     */
    requestBody: MandantDaten,
  }): CancelablePromise<Mandant> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/mandanten',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized for this request (createMandant)`,
        403: `Forbidden for this request (createMandant)`,
      },
    });
  }

  /**
   * Einen Mandanten bekommen
   * Bekomme einen Mandanten
   * @returns Mandant Der Mandant
   * @throws ApiError
   */
  public getMandant({
    mandantId,
  }: {
    /**
     * Eindeutige ID des Mandanten für (getMandant)
     */
    mandantId: string,
  }): CancelablePromise<Mandant> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/mandanten/{mandantId}',
      path: {
        'mandantId': mandantId,
      },
      errors: {
        401: `Unauthorized for this request (getMandant)`,
        403: `Forbidden for this request (getMandant)`,
        404: `Not Found for this request (getMandant)`,
      },
    });
  }

  /**
   * Einen Mandanten aktualisieren
   * Aktualisiert einen Mandanten
   * @returns Mandant Der aktualisierte Mandant
   * @throws ApiError
   */
  public updateMandant({
    mandantId,
    requestBody,
  }: {
    /**
     * Eindeutige ID des Mandanten für (updateMandant)
     */
    mandantId: string,
    /**
     * Daten, mit welchen der Mandant aktualisiert werden soll
     */
    requestBody: MandantDaten,
  }): CancelablePromise<Mandant> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/v1/mandanten/{mandantId}',
      path: {
        'mandantId': mandantId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized for this request (updateMandant)`,
        403: `Forbidden for this request (updateMandant)`,
        404: `Not Found for this request (updateMandant)`,
      },
    });
  }

  /**
   * Einen Mandanten löschen
   * Löscht einen Mandanten
   * @returns Mandant Der gelöschte Mandant
   * @throws ApiError
   */
  public deleteMandant({
    mandantId,
  }: {
    /**
     * Eindeutige ID des Mandanten für (deleteMandant)
     */
    mandantId: string,
  }): CancelablePromise<Mandant> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/v1/mandanten/{mandantId}',
      path: {
        'mandantId': mandantId,
      },
      errors: {
        401: `Unauthorized for this request (deleteMandant)`,
        403: `Forbidden for this request (deleteMandant)`,
        404: `Not Found for this request (deleteMandant)`,
      },
    });
  }

  /**
   * Feiertage eines Mandanten auflisten
   * Liste aller hinterlegten Feiertage (mandantenbezogen) gefiltert nach Landesvorwahl und Jahr.
   * @returns FreeDayListe Liste von Feiertagen
   * @throws ApiError
   */
  public searchMandantFreedays({
    mandantId,
    year,
    countryCode,
    search,
    filtered,
    page,
    limit,
    sort,
  }: {
    /**
     * Eindeutige ID des Mandanten
     */
    mandantId: string,
    /**
     * Jahr, für das die Feiertage gefiltert werden
     */
    year?: number,
    countryCode?: string,
    /**
     * Suchstring für Mandanten
     */
    search?: string,
    /**
     * Filterstring für Freeday Seite
     */
    filtered?: string,
    /**
     * Seitenzahl der Freeday Seite
     */
    page?: number,
    /**
     * Limit der Liste von Freeday Einträgen
     */
    limit?: number,
    /**
     * Sortierung der Freeday Seite
     */
    sort?: string,
  }): CancelablePromise<FreeDayListe> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/mandanten/{mandantId}/freedays',
      path: {
        'mandantId': mandantId,
      },
      query: {
        'year': year,
        'countryCode': countryCode,
        'search': search,
        'filtered': filtered,
        'page': page,
        'limit': limit,
        'sort': sort,
      },
      errors: {
        401: `Unauthorized for this request (listMandantFreedays)`,
        403: `Forbidden for this request (listMandantFreedays)`,
        404: `Not Found for this request (listMandantFreedays)`,
      },
    });
  }

  /**
   * Feiertage hinzufügen
   * Fügt einen oder mehrere Feiertage für einen Mandanten hinzu. Optionaler Import mehrerer Einträge (z. B. CSV verarbeitet im Frontend, hier als Liste).
   * @returns FreeDayCreatedListe Angelegte Feiertage
   * @throws ApiError
   */
  public addMandantFreedays({
    mandantId,
    requestBody,
  }: {
    /**
     * Eindeutige ID des Mandanten
     */
    mandantId: string,
    requestBody: Array<FreeDayCreate>,
  }): CancelablePromise<FreeDayCreatedListe> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/mandanten/{mandantId}/freedays',
      path: {
        'mandantId': mandantId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Ungültige Eingabe`,
        401: `Unauthorized for this request (addMandantFreedays)`,
        403: `Forbidden for this request (addMandantFreedays)`,
      },
    });
  }

  /**
   * Feiertage löschen
   * Löscht genau einen Feiertag für einen Mandanten
   * @returns void
   * @throws ApiError
   */
  public deleteMandantFreedays({
    mandantId,
    freedayId,
  }: {
    /**
     * Eindeutige ID des Mandanten
     */
    mandantId: string,
    /**
     * Eindeutige ID des Freedays
     */
    freedayId: string,
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/v1/mandanten/{mandantId}/freedays/{freedayId}',
      path: {
        'mandantId': mandantId,
        'freedayId': freedayId,
      },
      errors: {
        401: `Unauthorized for this request (deleteMandantFreedays)`,
        403: `Forbidden for this request (deleteMandantFreedays)`,
        404: `Not Found for this request (deleteMandantFreedays)`,
      },
    });
  }

}
